import { Button, ButtonProps } from '@mui/material';

interface CancelButtonProps extends ButtonProps {
  onClick: () => void;
  children?: React.ReactNode;
}

export const CancelButton = ({ onClick, children = '취소', ...props }: CancelButtonProps) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        whiteSpace: 'nowrap', 
        minWidth: 120, 
        color: '#111', 
        backgroundColor: 'transparent', 
        boxShadow: 'none', 
        fontWeight: 400,
        border: '1.5px solid #eee', 
        '&:hover': {
          background: 'transparent',
          borderColor: '#CDCDCD',
        },
        transition: 'all 0.3s ease'
      }}
      {...props}
    >
      {children}
    </Button>
  );
}; 